<!-- 器械百科 分类 -->
<template>
	<div class="instrument-classify">
		<div class="bgimg">
			<img :src="brand_img" alt="">
		</div>
		<div class="content">
			<div class="father-item" v-for="(item,index) in classifyList" :key="index">
				<h4>{{index}}</h4>
				<div class="child-item-wrap">
					<div class="child-item" v-for="(value,ind) in item" :key="ind" @click="skipDetails(value.id)">
						<img :src="value.banner" alt="">
						<span>{{value.name}}</span>
					</div>					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {InstrumentBrandClasses} from "../../config/interface.js";
	export default{
		data(){
			return{
				active:0,
				brand_id:0,     //品牌id
				brand_img:'',   //品牌图片
				classifyList:[], //分类列表
			}
		},
		mounted(){
			this.brand_id=this.$route.query.id;
			this.brand_img=this.$route.query.brandImg;
			//微信浏览器  请求jsdk
			if(common.is_weixin()){
				common.moduleDetails(5);
			}
				this.init();
		},
		methods:{
			//品牌器械分类
			init(){
				const url=InstrumentBrandClasses;
				let params={
					brand_id:this.brand_id
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.classifyList=data;
					}
				})
			},
			//跳转到详情页
			skipDetails(id){
				this.$router.push({
					path:'/instrument/details',
					query:{
						id:id
					}
				})
			}
		}
		
	}
</script>
<style lang="scss">
	.instrument-classify{
		.bgimg{
			img{
				width:100%;
				/*height:170px;*/
			}
		}
		.content{
			h4{
				background: #F1F2F4;
				font-size: 17px;
				color: #090909;
				letter-spacing: 0.6px;
				padding:5px 12px;
				box-sizing:border-box;
			}
			.father-item{
				.child-item-wrap{
					padding:0 12px;
					box-sizing:border-box;
				}
				.child-item{
					@include flex(row);
					border-bottom: 1px solid #BFBFBF;
					height:82px;
					align-items:center;
					img{
						width:80px;
						margin-right:12px;
					}
					span{
						font-size: 14px;
						color: #090909;
						letter-spacing: 0.49px;
					}

				}
				.child-item:last-child{
					border:0px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/brand.vue